import { MdPictureAsPdf } from 'react-icons/md'
import { HiDuplicate } from 'react-icons/hi'

import { VscFilePdf } from 'react-icons/vsc'
import Swal from 'sweetalert2';
import { urlApiServer } from '../../Config/Config';
import { FaUserEdit, FaUserTimes, FaPencilAlt, FaTrashAlt, FaUserCog, FaUserMinus, FaPencilRuler, FaTrash, FaClipboardList } from 'react-icons/fa';
import '../../styles/Quotes.css'
import { NavLink } from 'react-router-dom';
import { useEffect, useState, useContext, useRef } from 'react';
import LoginContext from "../../Context/Logincontext"
import { RiFileList2Line } from 'react-icons/ri'


export const columnsQuotesAdmin = [
  {
    Header: "Estado",
    Cell: props => {
      console.log('props.row.original state: ', props.row.original)

      const urlState = urlApiServer + "editState";
      const urlRemission = urlApiServer + "remission";

      const [estado, setEstado] = useState('cotizado');
      const [botonColor, setBotonColor] = useState('#BF78B9');
      const [uniqueMaterials, setUniqueMaterials] = useState([]);
      const [materialIds, setMaterialIds] = useState([{ id: 0, missing: 0 }]);
      const [showWarning, setShowWarning] = useState(false);
      const [problematicMaterials, setProblematicMaterials] = useState([]);
      const [showAlert, setShowAlert] = useState(true);
      const [pendingStateUpdate, setPendingStateUpdate] = useState(null);
      const { infoUser, setInfoUser } = useContext(LoginContext)


      const materialIdsRef = useRef(materialIds);

      useEffect(() => {
        materialIdsRef.current = materialIds;
        if (props.row.original.subtracted !== 1) {
          setShowAlert(false);
        }

        // Si hay una actualización de estado pendiente y materialIds está actualizado
        if (pendingStateUpdate) {
          const { nuevoEstado, nuevoColor, nuevoEstadoEnum } = pendingStateUpdate;
          executeStateUpdate(nuevoEstado, nuevoColor, nuevoEstadoEnum);
          setPendingStateUpdate(null); // Limpiar el estado pendiente
        }
      }, [materialIds]);

      useEffect(() => {
        if (props.row.original.estado === 'Anulada') {
          setEstado('anulada')
          setBotonColor('#770000')
        } else if (props.row.original.estado === 'cotizado') {
          setEstado('cotizado')
          setBotonColor('#BF78B9')
        } else if (props.row.original.estado === 'aprobado') {
          setEstado('aprobado')
          setBotonColor('#8D70D3')
        } else if (props.row.original.estado === 'terminado') {
          setEstado('terminado')
          setBotonColor('#D37070')
        } else if (props.row.original.estado === 'facturado') {
          setEstado('facturado')
          setBotonColor('#D3D270')
        } else {
          setEstado('entregado')
          setBotonColor('#70D378')
        }
      }, [props.row.original.estado])

      let siguienteEstado;
      console.log("estado: ", estado)
      if (estado === 'cotizado') {
        siguienteEstado = 'aprobado';
      } else if (estado === 'aprobado') {
        siguienteEstado = 'terminado';
      } else if (estado === 'terminado') {
        siguienteEstado = 'facturado';
      } else if (estado === 'facturado') {
        siguienteEstado = 'entregado';
      } else {
        siguienteEstado = 'cotizado';
      }

      useEffect(() => {
        const fetchMaterialData = async () => {
          if (uniqueMaterials.length === 0) return;

          const problematicItems = [];

          for (const material of uniqueMaterials) {
            try {
              const urlGetRawMaterialid = urlApiServer + `rawMaterialid/${material.material}/${infoUser.company}`;
              const response = await fetch(urlGetRawMaterialid, {
                method: 'GET',
                headers: { "Content-Type": "application/json" },
                redirect: 'follow'
              });
              const rawMaterialid = await response.json();
              if (rawMaterialid.length > 0) {
                const amount = rawMaterialid[0].amount;
                const needed = parseInt(material.quantity);
                if (needed > parseInt(amount)) {
                  problematicItems.push({
                    name: material.material,
                    available: amount,
                    missing: needed - amount,
                    id: rawMaterialid[0].id
                  });
                } else {
                  const { nuevoEstado, nuevoColor, nuevoEstadoEnum } = pendingStateUpdate;
                  executeStateUpdate(nuevoEstado, nuevoColor, nuevoEstadoEnum);
                  setPendingStateUpdate(null); // Limpiar el estado pendiente
                }
              }
            } catch (error) {
              console.error('Error fetching material:', error);
            }
          }

          if (problematicItems.length > 0) {
            setProblematicMaterials(problematicItems);
            setShowWarning(true);

            // Actualizar materialIds con todos los materiales problemáticos
            setMaterialIds(prev => {
              const filtered = prev.filter(item => item.id !== 0);
              const newItems = problematicItems.map(item => ({
                id: item.id,
                missing: item.missing
              }));
              return [...filtered, ...newItems];
            });
          }
        };

        fetchMaterialData();
      }, [uniqueMaterials]);

      const mostrarAdvertencia = () => {
        if (props.row.original.subtracted === 1 || problematicMaterials.length === 0) return null;
        const message = `
          <div style="max-height: 60vh; overflow-y: auto;">
            <table style="width: 100%; border-collapse: collapse; text-align: left;">
              <thead>
                <tr style="background-color: #f8d7da; color: #721c24;">
                  <th style="padding: 8px; border-bottom: 2px solid #dc3545;">Material</th>
                  <th style="padding: 8px; border-bottom: 2px solid #dc3545;">Disponible</th>
                  <th style="padding: 8px; border-bottom: 2px solid #dc3545;">Faltante</th>
                </tr>
              </thead>
              <tbody>
                ${problematicMaterials.map(material => `
                  <tr>
                    <td style="padding: 8px; border-bottom: 1px solid #ddd;"><strong>${material.name}</strong></td>
                    <td style="padding: 8px; border-bottom: 1px solid #ddd;">${material.available}</td>
                    <td style="padding: 8px; border-bottom: 1px solid #ddd; color: red; font-weight: bold;">${material.missing}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;

        return Swal.fire({
          icon: 'warning',
          title: 'Materiales Insuficientes',
          html: message,
          confirmButtonText: 'Entendido',
          allowOutsideClick: false,
          confirmButtonColor: "#ff0000",
          showCancelButton: false,
          showConfirmButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: 'Estado Actualizado',
              text: `El estado ahora es: aprobado`,
              icon: 'success'
            });
            setShowAlert(true)
          }
        });
      };

      useEffect(() => {
        if (showWarning && props.row.original.subtracted !== 1) {
          mostrarAdvertencia().then(() => {
            setShowWarning(false);
          });
        }
      }, [showWarning, problematicMaterials]);

      const executeStateUpdate = async (nuevoEstado, nuevoColor, nuevoEstadoEnum) => {
        try {
          console.log("urlState: ", urlState)
          const response = await fetch(urlState, {
            method: 'PUT',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              empresa: infoUser.company,
              nrocotizacion: props.row.original.nrocotizacion,
              state: nuevoEstadoEnum,
              missinginventoryquantity: JSON.stringify(materialIdsRef.current),
            }),
            redirect: 'follow'
          });
          console.log("response executeStateUpdate: ", response)
          const dataResponse = await response.json();
          console.log('dataResponse: ', dataResponse);
          setEstado(nuevoEstado);
          setBotonColor(nuevoColor);
          props.functionNew();

          if (showAlert === true) {
            Swal.fire({
              title: 'Estado Actualizado',
              text: `El estado ahora es: ${nuevoEstado}`,
              icon: 'success'
            });
          }
        } catch (err) {
          console.error('Error al actualizar estado:', err);
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error al actualizar el estado',
            icon: 'error'
          });
        }
      };

      const cambiarEstado = async () => {
        if (props.row.original.estado === 'Anulada') {
          Swal.fire({
            title: 'Acción cancelada',
            text: 'No puedes cambiar este estado, debes de ser administrador para esta acción',
            icon: 'info'
          });
          return;
        }
        console.log("siguienteEstado: ", siguienteEstado)
        let nuevoEstado, nuevoColor, nuevoEstadoEnum;
        await Swal.fire({
          title: `¿Estás seguro de actualizar a ${siguienteEstado}?`,
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar'
        }).then(async (res) => {
          if (res.isConfirmed) {
            console.log("estado: ", estado)
            if (estado === 'cotizado') {
              nuevoEstado = 'aprobado';
              nuevoColor = '#8D70D3';
              nuevoEstadoEnum = 2;

              // Verificar si hay materiales para restar
              const materials = props.row.original.materials || [];

              console.log("antes executeStateUpdate: ")
              // Si no hay materiales o subtracted ya es 1, proceder directamente
              if (materials.length === 0 || props.row.original.subtracted === 1) {
                console.log("materials executeStateUpdate: ", materials)
                await executeStateUpdate(nuevoEstado, nuevoColor, nuevoEstadoEnum);
                return;
              }

              // Si hay materiales, proceder con la verificación
              const unique = Array.from(new Map(materials.map(m => [m.material, m])).values());
              console.log("unique: ", unique)
              setUniqueMaterials(Array.from(unique));

              // En lugar de hacer la petición inmediatamente, guardamos los parámetros
              setPendingStateUpdate({ nuevoEstado, nuevoColor, nuevoEstadoEnum });
              return;
            }
            // Resto de condiciones de estado...
            else if (estado === 'aprobado') {
              nuevoEstado = 'terminado';
              nuevoColor = '#D37070';
              nuevoEstadoEnum = 3;
            } else if (estado === 'terminado') {
              nuevoEstado = 'facturado';
              nuevoColor = '#D3D270';
              nuevoEstadoEnum = 4;
            } else if (estado === 'facturado') {
              nuevoEstado = 'entregado';
              nuevoColor = '#70D378';
              nuevoEstadoEnum = 5;

              const data = JSON.stringify({
                nrocotizacion: props.row.original.nrocotizacion,
              });

              await fetch(urlRemission, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: data,
                redirect: 'follow'
              });
            } else {
              nuevoEstado = 'cotizado';
              nuevoColor = '#BF78B9';
              nuevoEstadoEnum = 1;
            }

            console.log("EJECUTANDO EXECUTESTATEUPDATE")
            await executeStateUpdate(nuevoEstado, nuevoColor, nuevoEstadoEnum);
          } else {
            // if (!result.isConfirmed) {
            Swal.fire({
              title: 'Acción cancelada',
              text: 'No se ha actualizado el estado',
              icon: 'info'
            });
            return;
            // }
          }
        })
      };

      return (
        <div>
          <button
            style={{ backgroundColor: botonColor }}
            className='buttonState'
            onClick={cambiarEstado}
          >
            {estado}
          </button>
        </div>
      );
    }
  },
  {
    Header: "Nro",
    accessor: "nrocotizacion",
  },
  {
    Header: "Fecha de realización",
    accessor: "fecha",
    Cell: ({ value }) => {
      const fechaOriginal = new Date(value);
      const fechaFormateada = fechaOriginal.toLocaleDateString();
      return <span>{fechaFormateada}</span>;
    }
  },
  // {
  //   Header: "Fecha Entrega",
  //   accessor: "fechaentrega"
  // },
  {
    Header: "Nombre del asesor",
    accessor: "asesor"
  },
  // {
  //   Header: "Documento",
  //   accessor: "nitocc"
  // },
  // {
  //   Header: "Direccion",
  //   accessor: "direccion"
  // },
  {
    Header: "Nombre del cliente",
    accessor: "cliente"
  },
  {
    Header: "Tel del cliente",
    accessor: "telefono"
  },
  {
    Header: "Abono",
    accessor: "abono",
    Cell: ({ value }) => {
      const abono = value || 0;
      return <span>{abono}</span>;
    }
  },
  {
    Header: "Debe",
    accessor: "debe"
  },
  {
    Header: "Factura",
    accessor: "nrofactura",
    Cell: props => {

      let indexReturned = 0


      props.data.map((itemTable, index) => {
        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index

        }
      })

      async function on() {
        // props.showLoader(indexReturned, props.row.original.nrocotizacion)
        // props.power()
        console.log("ORIGINAL: ", props.row)
        props.importantData(indexReturned)
        props.handleShowBill(props.row.original)
        // props.showLoader()
      }

      return (
        <>
          <div className='iconsPdf'>
            <NavLink onClick={on}><FaClipboardList className='iconPdf' /></NavLink>
          </div>
        </>
      )

      // const abono = value || 0;
      // return <span>{abono}</span>;
    }
  },
  {
    Header: "Pdf",
    Cell: props => {

      let indexReturned = 0


      props.data.map((itemTable, index) => {
        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index

        }
      })

      async function on() {
        props.showLoader(indexReturned, props.row.original.nrocotizacion)
        // props.power()
        props.importantData(indexReturned)
        props.id(props.row.original.nrocotizacion)
        // props.showLoader()
      }
      return (
        <>
          <div className='iconsPdf'>
            <NavLink onClick={on}><VscFilePdf className='iconPdf' /></NavLink>
          </div>
        </>
      )
    }
  },
  {
    Header: "Duplicar",
    Cell: props => {

      const urlDuplicateQuotes = urlApiServer + "duplicatequotes";

      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function duplicate() {

        const data = JSON.stringify({
          empresa: infoUser.company,
          nrocotizacion: props.row.original.nrocotizacion
        })
        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
          method: 'POST',
          headers: registerHeaders,
          body: data,
          redirect: 'follow'
        }

        fetch(urlDuplicateQuotes, requesoption)
          .then((response) => response.json())
          .then((dataResponse) => {
            if (dataResponse.msj !== 'Cotización duplicada exitosamente') {
              Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Algo salió mal',
              });
              return
            }

            // Validar si todas las respuestas fueron exitosas y contienen el mensaje esperado
            if (dataResponse.status === 300) {
              Swal.fire({
                icon: 'success',
                title: 'Felicidades',
                text: 'Has duplicado la cotización',
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false,
              }).then((result) => {
                if (result.isConfirmed) {
                  props.functionNew();
                }
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: 'Algo salió mal',
              });
            }

          })

      }
      return (
        <>
          <NavLink><HiDuplicate className='iconDuplicate' onClick={duplicate} /></NavLink>
        </>)
    }
  },
  {
    Header: "Remisión",
    Cell: props => {

      if (props.row.original.estado === 'entregado') {

        let indexReturned = 0

        props.data.map((itemTable, index) => {

          if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
            indexReturned = index

          }
        })

        async function on() {
          props.remission()
          props.importantData(indexReturned)
          props.id(props.row.original.nrocotizacion)
        }
        return (
          <>
            <div className='iconsPdf'>
              <NavLink onClick={on}><RiFileList2Line className='iconPdf' /></NavLink>
            </div>
          </>
        )
      }
    }
  }, {
    Header: "Editar",
    Cell: props => {

      let indexReturned = 0

      props.data.map((itemTable, index) => {

        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index
        }
      })

      async function on() {
        props.edit()
        props.importantData(indexReturned)
        props.id(props.row.original.nrocotizacion)
      }
      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "Borrar-quotes";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar esta cotización?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              nrocotizacion: props.row.original.nrocotizacion,
              ImageDelete: props.row.original.image
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar Cotizacion' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Cotizacion Eliminada',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }
      return (
        <>
          <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
        </>)
    }
  },
]

export const columnsEmployeesAdmin = [
  {
    Header: "Id",
    accessor: "Id",
  },
  {
    Header: "Nombre",
    accessor: "name"
  },
  {
    Header: "Numero de Documento",
    accessor: "number_document"
  },
  {
    Header: "Tipo de Documento",
    accessor: "type_document"
  },
  {
    Header: "Cargo",
    accessor: "position"
  },
  {
    Header: "Editar",
    Cell: props => {

      let indexReturned = 0
      console.log("props: ", props.data)
      // props.data.map((itemTable, index) => {

      //   if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
      //     indexReturned = index
      //   }
      // })

      async function on() {
        props.handleModify(props.row.original)
        props.edit()
        props.importantData(indexReturned)
        props.id(props.row.original.nrocotizacion)
      }
      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "deleteemployee";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar este empleado?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              id: props.row.original.Id,
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if (data.status === 200) {
                  Swal.fire({
                    icon: 'success',
                    title: data.msj,
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }
      return (
        <>
          <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
        </>)
    }
  },
]

export const columnsSuppliersAdmin = [
  {
    Header: "Id",
    accessor: "Id",
  },
  {
    Header: "Nombre de la empresa",
    accessor: "name"
  },
  {
    Header: "Nombre del encargado",
    accessor: "contact_name"
  },
  {
    Header: "Telefono",
    accessor: "phone"
  },
  {
    Header: "Correo",
    accessor: "email"
  },
  {
    Header: "Direccion",
    accessor: "address"
  },
  {
    Header: "Ciudad",
    accessor: "city"
  },
  {
    Header: "Pais",
    accessor: "country"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.id(props.row.original.id)
        props.edit()
        props.handleModify(props.row.original)
      }
      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "deletesuppliers";
      const { infoUser } = useContext(LoginContext)

      async function Eliminar() {

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar este proveddor?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              id: props.row.original.Id,
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if (data.ok === 200) {
                  Swal.fire({
                    icon: 'success',
                    title: data.msj,
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }
      return (
        <>
          <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
        </>)
    }
  },
]

export const columnsInventoryAdmin = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Nombre del material",
    accessor: "nameofmaterial"
  },
  {
    Header: "Cantidad",
    accessor: "amount"
  },
  {
    Header: "Tipo de medida",
    accessor: "typeOfMeasure"
  },
  {
    Header: "Precio por medida",
    accessor: "pricePerMeasure"
  },
  {
    Header: "Disponibilidad",
    accessor: "availability"
  },
  {
    Header: "Cantidad faltante",
    accessor: "missingamount"
  },
  {
    Header: "Editar",
    Cell: props => {

      let indexReturned = 0
      console.log("props: ", props.data)
      // props.data.map((itemTable, index) => {

      //   if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
      //     indexReturned = index
      //   }
      // })

      async function on() {
        console.log("props.row.original: ", props.row.original.id)
        props.id(props.row.original.id)
        props.edit()
        // props.importantData(indexReturned)
      }
      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "deleteRawMaterial";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar este material del inventario?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              id: props.row.original.id,
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar Cotizacion' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Material del inventario eliminado',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }
      return (
        <>
          <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
        </>)
    }
  },
]

export const columnsCompositeproductAdmin = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Producto",
    accessor: "product"
  },
  {
    Header: "Mano de obra",
    accessor: "laborprice"
  },
  {
    Header: "Cantidad por defecto",
    accessor: "quantityOfProducts"
  },
  {
    Header: "Unidad de medida",
    accessor: "unit"
  },
  {
    Header: "Iva",
    accessor: "vat",
    Cell: ({ value }) => `${value}%` // Esto agregará el símbolo % al valor
  },
  {
    Header: "Precio total",
    accessor: "totalPrice"
  },
  {
    Header: "Editar",
    Cell: props => {

      let indexReturned = 0
      console.log("props: ", props.data)
      // props.data.map((itemTable, index) => {

      //   if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
      //     indexReturned = index
      //   }
      // })

      async function on() {
        console.log("props.row.original: ", props.row.original.id)
        props.id(props.row.original.id)
        props.edit()
        // props.importantData(indexReturned)
      }
      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "deleteCompositeproduct";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar este producto?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              id: props.row.original.id,
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar Cotizacion' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Cotizacion Eliminada',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }
      return (
        <>
          <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
        </>)
    }
  },
]

export const columnsCompositeproduct = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Producto",
    accessor: "product"
  },
  {
    Header: "Mano de obra",
    accessor: "laborprice"
  },
  {
    Header: "Cantidad por defecto",
    accessor: "quantityOfProducts"
  },
  {
    Header: "Unidad de medida",
    accessor: "quantityOfProducts"
  },
  {
    Header: "Iva",
    accessor: "vat"
  },
  {
    Header: "Precio total",
    accessor: "totalPrice"
  },
  // {
  //   Header: "Editar",
  //   Cell: props => {

  //     let indexReturned = 0
  //     console.log("props: ", props.data)
  //     // props.data.map((itemTable, index) => {

  //     //   if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
  //     //     indexReturned = index
  //     //   }
  //     // })

  //     async function on() {
  //       console.log("props.row.original: ", props.row.original.id)
  //       props.id(props.row.original.id)
  //       props.edit()
  //       // props.importantData(indexReturned)
  //     }
  //     return (
  //       <>
  //         <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
  //       </>
  //     )
  //   }
  // },
  // {
  //   Header: "Borrar",
  //   Cell: props => {
  //     const urleliminar = urlApiServer + "Borrar-quotes";
  //     const { infoUser, setInfoUser } = useContext(LoginContext)

  //     async function Eliminar() {

  //       Swal.fire({
  //         icon: 'warning',
  //         title: '¿Estas seguro?',
  //         text: '¿Seguro que quieres eliminar este producto?',
  //         allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
  //         confirmButtonText: 'Aceptar',
  //         showCancelButton: true
  //       }).then(async (resultConfirm) => {
  //         if (resultConfirm.isConfirmed) {

  //           const data = JSON.stringify({
  //             empresa: infoUser.company,
  //             nrocotizacion: props.row.original.nrocotizacion,
  //             ImageDelete: props.row.original.image
  //           })
  //           const eliminarHeaders = new Headers();
  //           eliminarHeaders.append("Content-Type", "application/json")

  //           const requesoption = {
  //             method: 'DELETE',
  //             headers: eliminarHeaders,
  //             body: data,
  //             redirect: 'follow',
  //           }

  //           await fetch(urleliminar, requesoption).then(response => response.json())
  //             .then(data => {
  //               if ('Borrar Cotizacion' === data.msj) {
  //                 Swal.fire({
  //                   icon: 'success',
  //                   title: 'Cotizacion Eliminada',
  //                   text: 'Has eliminado este dato correctamente',
  //                 })
  //               }
  //             })
  //           props.functionNew()
  //         }
  //       })
  //     }
  //     return (
  //       <>
  //         <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
  //       </>)
  //   }
  // },
]

export const columnsQuotes = [
  {
    Header: "Nro",
    accessor: "nrocotizacion"
  },
  {
    Header: "Fecha de realización",
    accessor: "fecha",
    Cell: ({ value }) => {
      const fechaOriginal = new Date(value);
      const fechaFormateada = fechaOriginal.toLocaleDateString();
      return <span>{fechaFormateada}</span>;
    }
  },
  // {
  //   Header: "Fecha Entrega",
  //   accessor: "fechaentrega"
  // },
  {
    Header: "Nombre del asesor",
    accessor: "asesor"
  },
  // {
  //   Header: "Documento",
  //   accessor: "nitocc"
  // },
  // {
  //   Header: "Direccion",
  //   accessor: "direccion"
  // },
  {
    Header: "Nombre del cliente",
    accessor: "cliente"
  },
  {
    Header: "Tel del cliente",
    accessor: "telefono"
  },
  {
    Header: "Abono",
    accessor: "abono",
    Cell: props => {
      // const [abono, setAbono] = useState()

      // useEffect(() => {
      //   if (props.row.original.abono == "") {
      //     <p>0</p>
      //   } else {
      //     setAbono(new Intl.NumberFormat('es-MX').format(props.row.original.abono).replace(/,/g, '.'))
      //   }
      // }, [props])

      // return (
      //   <p>{abono}</p>
      // )

      let indexReturned = 0

      props.data.map((itemTable, index) => {
        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index

        }
      })

      async function on() {
        props.showLoader()
        props.power()
        props.importantData(indexReturned)
        props.id(props.row.original.nrocotizacion)
      }

      return (
        <>
          <div className='iconsPdf'>
            <NavLink onClick={on}><MdPictureAsPdf className='iconPdf' /></NavLink>
          </div>
        </>
      )

    }
  },
  {
    Header: "Factura",
    accessor: "nrofactura",
    Cell: ({ value }) => {
      const abono = value || 0;
      return <span>{abono}</span>;
    }
  },
  {
    Header: "Pdf",
    Cell: props => {

      let indexReturned = 0

      props.data.map((itemTable, index) => {
        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index

        }
      })

      async function on() {
        props.showLoader()
        props.power()
        props.importantData(indexReturned)
        props.id(props.row.original.nrocotizacion)
      }
      return (
        <>
          <div className='iconsPdf'>
            <NavLink onClick={on}><MdPictureAsPdf className='iconPdf' /></NavLink>
          </div>
        </>
      )
    }
  }, {
    Header: "Remisión",
    Cell: props => {

      if (props.row.original.estado === 'entregado') {

        let indexReturned = 0


        props.data.map((itemTable, index) => {

          if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
            indexReturned = index

          }
        })

        async function on() {
          props.remission()
          props.importantData(indexReturned)
          props.id(props.row.original.nrocotizacion)
        }
        return (
          <>
            <div className='iconsPdf'>
              <NavLink onClick={on}><RiFileList2Line className='iconPdf' /></NavLink>
            </div>
          </>
        )
      }
    }
  }, {
    Header: "Editar",
    Cell: props => {

      let indexReturned = 0

      props.data.map((itemTable, index) => {
        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index
        }
      })

      async function on() {
        props.edit()
        props.importantData(indexReturned)
        props.id(props.row.original.nrocotizacion)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Estado",
    Cell: props => {

      const urlState = urlApiServer + "editState";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      const urlRemission = urlApiServer + "remission";

      const [estado, setEstado] = useState('cotizado');
      const [botonColor, setBotonColor] = useState('#BF78B9');

      useEffect(() => {
        if (props.row.original.estado === 'cotizado') {
          setEstado('cotizado')
          setBotonColor('#BF78B9')
        } else if (props.row.original.estado === 'aprobado') {
          setEstado('aprobado')
          setBotonColor('#8D70D3')
        } else if (props.row.original.estado === 'terminado') {
          setEstado('terminado')
          setBotonColor('#D37070')
        } else if (props.row.original.estado === 'facturado') {
          setEstado('facturado')
          setBotonColor('#D3D270')
        } else {
          setEstado('entregado')
          setBotonColor('#70D378')
        }
      }, [props.row.original.estado])

      let siguienteEstado;
      if (estado === 'cotizado') {
        siguienteEstado = 'aprobado';
      } else if (estado === 'aprobado') {
        siguienteEstado = 'terminado';
      } else if (estado === 'terminado') {
        siguienteEstado = 'facturado';
      } else if (estado === 'facturado') {
        siguienteEstado = 'entregado';
      } else {
        siguienteEstado = 'cotizado';
      }

      const cambiarEstado = () => {
        Swal.fire({
          title: `¿Estás seguro de que deseas actualizar el estado a ${siguienteEstado}?`,
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            let nuevoEstado, nuevoColor, nuevoEstadoEnum;
            if (estado === 'cotizado') {
              nuevoEstado = 'aprobado';
              nuevoColor = '#8D70D3';
              nuevoEstadoEnum = 2;
            } else if (estado === 'aprobado') {
              nuevoEstado = 'terminado';
              nuevoColor = '#D37070';
              nuevoEstadoEnum = 3;
            } else if (estado === 'terminado') {
              nuevoEstado = 'facturado';
              nuevoColor = '#D3D270';
              nuevoEstadoEnum = 4;
            } else if (estado === 'facturado') {
              nuevoEstado = 'entregado';
              nuevoColor = '#70D378';
              nuevoEstadoEnum = 5;
              const data = JSON.stringify({
                empresa: infoUser.company,
                nrocotizacion: props.row.original.nrocotizacion,
              })
              const registerHeaders = new Headers();
              registerHeaders.append("Content-Type", "application/json")

              const requesoption = {
                method: 'POST',
                headers: registerHeaders,
                body: data,
                redirect: 'follow'
              }

              fetch(urlRemission, requesoption)
                .then((response) => response.json())
                .then((dataResponse) => {
                  props.functionNew()
                })
            } else {
              nuevoEstado = 'cotizado';
              nuevoColor = '#BF78B9';
              nuevoEstadoEnum = 1;
            }
            Swal.fire({
              title: 'Se actualizó el estado',
              text: `El estado ahora está (${nuevoEstado})`,
            });
            const data = JSON.stringify({
              empresa: infoUser.company,
              nrocotizacion: props.row.original.nrocotizacion,
              state: nuevoEstadoEnum
            });
            const registerHeaders = new Headers({
              "Content-Type": "application/json"
            });
            const requesoption = {
              method: 'PUT',
              headers: registerHeaders,
              body: data,
              redirect: 'follow'
            };
            fetch(urlState, requesoption)
              .then(response => response.json())
              .then((dataResponse) => {
                setEstado(nuevoEstado);
                setBotonColor(nuevoColor);
                props.functionNew()
              })
              .catch(err => console.log(err));
          } else {
            Swal.fire({
              title: 'Acción cancelada',
              text: 'No se ha actualizado el estado',
              icon: 'info'
            });
          }
        });
      };

      return (
        <div>
          <button style={{ backgroundColor: botonColor }} className='buttonState' onClick={cambiarEstado}>{estado}</button>
        </div>
      );

    }
  },
]

export const columnsClientAdmin = [
  {
    Header: "Nombre",
    accessor: "cliente"
  },
  {
    Header: "Telefono",
    accessor: "telefono"
  },
  {
    Header: "Contacto",
    accessor: "contacto"
  },
  {
    Header: "Correo",
    accessor: "correo"
  },
  {
    Header: "Documento",
    accessor: "nitocc"
  },
  {
    Header: "Direccion",
    accessor: "direccion"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaUserCog className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const { infoUser, setInfoUser } = useContext(LoginContext)

      const urleliminar = urlApiServer + "deleteClient";

      async function Eliminar() {


        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar este cliente?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              Id: props.row.original.Id,
              company: infoUser.company
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar cliente' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Cliente Eliminado',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }

      return (
        <>
          <NavLink><FaUserMinus onClick={Eliminar} className='iconPdf' /></NavLink>
        </>
      )
    }
  }
]

export const columnsClient = [
  {
    Header: "Nombre",
    accessor: "cliente"
  },
  {
    Header: "Telefono",
    accessor: "telefono"
  },
  {
    Header: "Contacto",
    accessor: "contacto"
  },
  {
    Header: "Correo",
    accessor: "correo"
  },
  {
    Header: "Documento",
    accessor: "nitocc"
  },
  {
    Header: "Direccion",
    accessor: "direccion"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaUserCog className='iconEdit' /></NavLink>
        </>
      )
    }
  }
]

export const columnsUsers = [
  {
    Header: "Nombre",
    accessor: "nombre"
  },
  {
    Header: "Apellidos",
    accessor: "apellidos"
  },
  {
    Header: "Tipo de documento",
    accessor: "tipo"
  },
  {
    Header: "Nro. Documento",
    accessor: "cc"
  },
  {
    Header: "Correo",
    accessor: "correo"
  },
  {
    Header: "Telefono",
    accessor: "telefono"
  },
  {
    Header: "Roles",
    accessor: "roles"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaUserEdit className='iconEdit' /></NavLink>
        </>
      )
    }
  }, {
    Header: "Borrar",
    Cell: props => {
      const { infoUser, setInfoUser } = useContext(LoginContext)
      const urleliminar = urlApiServer + "borrarUsers";

      async function Eliminar() {


        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar este usuario?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {

          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              Id: props.row.original.Id,
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar cliente' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Producto Eliminado',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }
      return (
        <>
          <NavLink><FaUserTimes onClick={Eliminar} className='iconPdf' /></NavLink>
        </>
      )
    }
  }
]

export const columnsProductsAdmin = [
  {
    Header: "Productos",
    accessor: "producto"
  },
  {
    Header: "Material",
    accessor: "material"
  },
  {
    Header: "Metrolineal",
    accessor: "largo"
  },
  {
    Header: "Ancho",
    accessor: "ancho"
  },
  {
    Header: "grosor",
    accessor: "calibre"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilRuler className='iconEdit' /></NavLink>
        </>
      )
    }
  }, {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "borrarProducto";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {
        // console.log("props.row.original: ", props.row.original)

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar este producto?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {
            const data = JSON.stringify({
              empresa: infoUser.company,
              Id: props.row.original.Id,
              image3d: props.row.original.preview,
              image2d: props.row.original.model

            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar Productos' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Producto Eliminado',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }

      return (
        <>
          <NavLink><FaTrash onClick={Eliminar} className='iconPdf' /></NavLink>
        </>
      )
    }
  }
]

export const columnsProductsAdminGeneric = [
  {
    Header: "Productos",
    accessor: "producto"
  },
  {
    Header: "Precio",
    accessor: "precioitem"
  },
  {
    Header: "Unidad",
    accessor: "unit"
  },
  {
    Header: "Iva",
    accessor: "iva"
  },
  {
    Header: "Editar",
    Cell: props => {
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function on() {
        if (infoUser.companyType === "Generica") {
          props.id(props.row.original.Id, props.row.original)
        } else {
          props.edit()
          props.id(props.row.original.Id, props.row.original)
        }
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilRuler className='iconEdit' /></NavLink>
        </>
      )
    }
  }, {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "borrarProducto";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {


        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar esta producto?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            // console.log("props.row.original: ", props.row.original)
            const data = JSON.stringify({
              empresa: infoUser.company,
              Id: props.row.original.Id,
              image3d: props.row.original.preview,
              image2d: props.row.original.model

            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar Productos' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Producto Eliminado',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }

      return (
        <>
          <NavLink><FaTrash onClick={Eliminar} className='iconPdf' /></NavLink>
        </>
      )
    }
  }
]

export const columnsProducts = [
  {
    Header: "Productos",
    accessor: "producto"
  },
  {
    Header: "Material",
    accessor: "material"
  },
  {
    Header: "Metrolineal",
    accessor: "largo"
  },
  {
    Header: "Ancho",
    accessor: "ancho"
  },
  {
    Header: "grosor",
    accessor: "calibre"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilRuler className='iconEdit' /></NavLink>
        </>
      )
    }
  }
]

export const columnsTexture = [
  {
    Header: "Material",
    accessor: "texture",
    Cell: props => {
      return (
        <img src={urlApiServer + "viewTexture/" + props.value} alt="Textura" className='textureImageDimensions' />
      );
    }
  },
  {
    Header: "Nombre del material",
    accessor: "nameTexture"
  },
  {
    Header: "Largo",
    accessor: "length"
  },
  {
    Header: "Ancho",
    accessor: "width"
  },
  {
    Header: "Precio",
    accessor: "price"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilRuler className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "deleteTexture";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {

        const data = JSON.stringify({
          empresa: infoUser.company,
          Id: props.row.original.Id,
          ImageDelete: props.row.original.texture
        })
        const eliminarHeaders = new Headers();
        eliminarHeaders.append("Content-Type", "application/json")

        const requesoption = {
          method: 'DELETE',
          headers: eliminarHeaders,
          body: data,
          redirect: 'follow',
        }
        Swal.fire({
          title: 'Eliminar Imagen',
          text: "Los productos con este material ya no se veran con este material, ¿Seguro?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Eliminar'
        }).then(async (result) => {
          if (result.isConfirmed) {
            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if (data.status === 200) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Textura Eliminada',
                    text: data.msj,
                  })
                }

                if (data.status === 304) {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.msj,
                  })
                }
              })
            props.functionNew()
          }
        })

      }

      return (
        <>
          <NavLink><FaTrash onClick={Eliminar} className='iconPdf' /></NavLink>
        </>
      )
    }
  }
]

export const columnsCompanyAdmin = [
  {
    Header: "Empresa",
    accessor: "nameCompany"
  },
  {
    Header: "Telefono",
    accessor: "companyPhone"
  },
  {
    Header: "Nit",
    accessor: "companyNit"
  },
  {
    Header: "Celular",
    accessor: "companyMobile"
  },
  {
    Header: "Direccion",
    accessor: "companyAddress"
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilRuler className='iconEdit' /></NavLink>
        </>
      )
    }
  }, {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "borrarProducto";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {
        // console.log("props.row.original: ", props.row.original)

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar esta compañia?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {
            const data = JSON.stringify({
              empresa: infoUser.company,
              Id: props.row.original.Id,
              image3d: props.row.original.preview,
              image2d: props.row.original.model

            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar Productos' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Producto Eliminado',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }

      return (
        <>
          <NavLink><FaTrash onClick={Eliminar} className='iconPdf' /></NavLink>
        </>
      )
    }
  }
]

export const columnsBillsAdmin = [
  {
    Header: "Code",
    accessor: "Id"
  },
  {
    Header: "Nombre",
    accessor: "nombre"
  },
  {
    Header: "Cedula",
    accessor: "cedula"
  },
  {
    Header: "Direccion",
    accessor: "direccion"
  },
  {
    Header: "Ciudad",
    accessor: "ciudad"
  },
  {
    Header: "Factura",
    accessor: "nrofactura",
    Cell: props => {

      let indexReturned = 0


      props.data.map((itemTable, index) => {
        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index

        }
      })

      async function on() {
        // props.showLoader(indexReturned, props.row.original.nrocotizacion)
        // props.power()
        console.log("ORIGINAL: ", props.row)
        props.importantData(indexReturned)
        props.handleShowBill(props.row.original)
        // props.showLoader()
        props.id(props.row.original.Id)

      }

      return (
        <>
          <div className='iconsPdf'>
            <NavLink onClick={on}><FaClipboardList className='iconPdf' /></NavLink>
          </div>
        </>
      )

      // const abono = value || 0;
      // return <span>{abono}</span>;
    }
  },
  {
    Header: "Editar",
    Cell: props => {

      let indexReturned = 0

      props.data.map((itemTable, index) => {

        if (props.row.original.Id === itemTable.Id) {
          indexReturned = index
        }
      })

      async function on() {
        props.edit()
        props.importantData(indexReturned)
        props.id(props.row.original.Id)
      }
      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urlremoveBill = urlApiServer + "removeBill";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar esta factura?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              id: props.row.original.Id,
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urlremoveBill, requesoption).then(response => response.json())
              .then(data => {
                if (200 === data.status) {
                  Swal.fire({
                    icon: 'success',
                    title: data.msj,
                    text: 'Has eliminado este dato correctamente',
                  })
                } else {
                  Swal.fire({
                    icon: 'success',
                    title: data.msj,
                    text: 'El servidor no pudo eliminar este dato, prueba intentando mas tarde',
                  })
                }
              })
            props.handleRefreshPage()
          }
        })
      }
      return (
        <>
          <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
        </>)
    }
  }
]

export const columnsBills = [
  {
    Header: "Code",
    accessor: "Id"
  },
  {
    Header: "Nombre",
    accessor: "nombre"
  },
  // {
  //   Header: "Telefono",
  //   accessor: "telefono"
  // },
  // {
  //   Header: "Cedula",
  //   accessor: "cedula"
  // },
  // {
  //   Header: "Direccion",
  //   accessor: "direccion"
  // },
  {
    Header: "Ciudad",
    accessor: "ciudad"
  },
  {
    Header: "Editar",
    Cell: props => {

      let indexReturned = 0

      props.data.map((itemTable, index) => {

        if (props.row.original.nrocotizacion === itemTable.nrocotizacion) {
          indexReturned = index
        }
      })

      async function on() {
        props.edit()
        props.importantData(indexReturned)
        props.id(props.row.original.nrocotizacion)
      }
      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaPencilAlt className='iconEdit' /></NavLink>
        </>
      )
    }
  },
  {
    Header: "Borrar",
    Cell: props => {
      const urleliminar = urlApiServer + "Borrar-quotes";
      const { infoUser, setInfoUser } = useContext(LoginContext)

      async function Eliminar() {

        Swal.fire({
          icon: 'warning',
          title: '¿Estas seguro?',
          text: '¿Seguro que quieres eliminar esta factura?',
          allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
          confirmButtonText: 'Aceptar',
          showCancelButton: true
        }).then(async (resultConfirm) => {
          if (resultConfirm.isConfirmed) {

            const data = JSON.stringify({
              empresa: infoUser.company,
              nrocotizacion: props.row.original.nrocotizacion,
              ImageDelete: props.row.original.image
            })
            const eliminarHeaders = new Headers();
            eliminarHeaders.append("Content-Type", "application/json")

            const requesoption = {
              method: 'DELETE',
              headers: eliminarHeaders,
              body: data,
              redirect: 'follow',
            }

            await fetch(urleliminar, requesoption).then(response => response.json())
              .then(data => {
                if ('Borrar Cotizacion' === data.msj) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Cotizacion Eliminada',
                    text: 'Has eliminado este dato correctamente',
                  })
                }
              })
            props.functionNew()
          }
        })
      }
      return (
        <>
          <NavLink><FaTrashAlt onClick={Eliminar} className='iconPdf' /></NavLink>
        </>)
    }
  },
  {
    Header: "Editar",
    Cell: props => {

      async function on() {
        props.edit()
        props.id(props.row.original.Id)
      }

      return (
        <>
          <NavLink onClick={on} className='Textregister'><FaUserCog className='iconEdit' /></NavLink>
        </>
      )
    }
  }
]